<template>
    <svg :height="radius * 2" :width="radius * 2">
        <circle
            :stroke="color"
            :stroke-dasharray="circumference + ' ' + circumference"
            :style="{
                strokeDashoffset: strokeDashoffset,
                'transition-duration': `${duration}s`,
            }"
            :stroke-width="stroke"
            fill="transparent"
            :r="normalizedRadius"
            :cx="radius"
            :cy="radius"
        />
    </svg>
</template>

<script>
export default {
    props: {
        radius: Number,
        progress: Number,
        stroke: Number,
        duration: Number,
        color: {
            type: String,
            default: 'black',
        },
    },
    data() {
        const normalizedRadius = this.radius - this.stroke;
        const circumference = normalizedRadius * 2 * Math.PI;

        return {
            normalizedRadius,
            circumference,
        };
    },
    computed: {
        strokeDashoffset() {
            return (
                this.circumference - (this.progress / 100) * this.circumference
            );
        },
    },
};
</script>

<style lang="scss" scoped>
circle {
    transition-property: stroke-dashoffset;
    transition-timing-function: linear;
    transform: rotate(-90deg);
    transform-origin: 50% 50%;
}
</style>
